// Added by Sejune Oh on 2019-09-10
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import axios from 'axios'
import { LicenseProps } from './LicenseStore'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface ResGetLicenseProps extends LicenseProps {}
export const reqGetLicense = async () => {
    return await axios.get<ResGetLicenseProps>('v1/mgmt/license')
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface ResGetMachineInfoProps {
    encrypted_machine_info_base64: string
}
export const reqGetMachineInfo = async () => {
    return await axios.get<ResGetMachineInfoProps>('v1/mgmt/license/machineinfo')
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface ReqRegisterLicenseKeyProps {
    serial_key: string
    license_data_base64: string
}
interface ResRegisterLicenseProps {}
export const reqRegisterLicense = async ({ serial_key, license_data_base64 }: ReqRegisterLicenseKeyProps) => {
    const licenseKeyProps: { [key: string]: string } = {}

    if (serial_key && serial_key !== '') {
        licenseKeyProps['serial_key'] = serial_key
    }

    if (license_data_base64 && license_data_base64 !== '') {
        licenseKeyProps['license_data_base64'] = license_data_base64
    }

    return await axios.post<ResRegisterLicenseProps>('v1/mgmt/license/register', { ...licenseKeyProps })
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface ResUnregisterLicenseProps {}
export const reqUnregisterLicense = async () => {
    return await axios.post<ResUnregisterLicenseProps>('v1/mgmt/license/unregister', {})
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface ResUpdateLicenseProps {}
export const reqUpdateLicenseProps = async () => {
    return await axios.put<ResUpdateLicenseProps>('v1/mgmt/license/update', {})
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const reqCheckLicenseServerConnection = async () => {
    return await axios.get('v1/mgmt/license/check-connection')
}